import SectionHead from "./SectionHead";
import { Reveal } from "./Reveal";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const Work = ({ t }) => (
  <section className="section section-alt" id="work" data-testid="work-section">
    <div className="wrap">
      <SectionHead eyebrow={t.workLabel} title={t.workTitle} intro={t.workIntro} />
      <div className="grid projects">
        {t.projects.map((p, i) => (
          <Reveal key={i} delay={(i % 2) * 0.12} className="project" data-testid={`project-card-${slug(p.name)}`}>
            {p.img && (
              <div className="project-media" data-testid={`project-image-${slug(p.name)}`}>
                <img src={p.img} alt={p.alt} width={p.w} height={p.h} loading="lazy" />
              </div>
            )}
            <span className="tag mono">{p.tag}</span>
            <h3>{p.name}</h3>
            <p>{p.desc}</p>
            <span className="status mono">{p.status}</span>
            {p.url ? (
              <a className="textlink" href={p.url} target="_blank" rel="noopener noreferrer" data-testid={`project-link-${slug(p.name)}`}>
                {p.link} <span className="arr">↗</span>
              </a>
            ) : p.link ? (
              <span className="textlink muted">{p.link}</span>
            ) : null}
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Work;
